<div class="sort-form">
  <div class="options">
    <ng-container *ngFor="let option of sortData">
      <button [ngClass]="{'selected': selected === option.value}" (click)="applySort(option.value)">{{ option?.name }}</button>
    </ng-container> 
  </div>
  <div class="footer">
    <button (click)="closeDialog()">Cancel</button>
  </div>
</div>